import { SITE_CONTACT_FIELDS, SITE_CONTACT_HEADING } from "@/constants/site";

/**
 * 공개 사이트(랜딩/연구소개/기관/연구성과) 공용 하단 푸터.
 * "Contact us." 블록(구 `ContactSection.tsx`)으로 구성된다.
 */
export default function SiteFooter() {
  return (
    <footer>
      <section className="bg-mindcast-navy-dark px-6 py-20 text-white">
        <div className="mx-auto max-w-6xl text-left">
          <h2 className="text-3xl font-bold sm:text-4xl">
            {SITE_CONTACT_HEADING}
          </h2>

          <dl className="mt-8 space-y-2">
            {SITE_CONTACT_FIELDS.map((field) => (
              <div key={field.label} className="flex justify-start gap-2">
                <dt className="font-medium text-white/70">{field.label}:</dt>
                <dd>
                  {field.href ? (
                    <a
                      href={field.href}
                      className="underline hover:text-white/80"
                    >
                      {field.value}
                    </a>
                  ) : (
                    field.value
                  )}
                </dd>
              </div>
            ))}
          </dl>
        </div>
      </section>
    </footer>
  );
}
